import { Theme } from '@mui/material';

export const darkTooltipSlotProps = (theme: Theme) => ({
  tooltip: { sx: { backgroundColor: theme.palette.grey[700] } },
  arrow: { sx: { color: theme.palette.grey[700] } },
});
